export default __webpack_public_path__ + "static/media/BBPS-Electricity.cc73ecac.svg";